import styled from 'styled-components'
import { Type } from '../../../../../types/Survey/Element'
import { Type as AnswerType } from '../../../../../types/Survey/Answer/Element'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { Survey } from '../../../../../types/Survey/Survey'
import { Answer } from '../../../../../types/Survey/Answer/Answer'
import DynamicOptionsWithNumberAndSelection from './AnswerElement/DynamicOptionsWithNumberAndSelection'
import OrganizationUnitNumberInput from './AnswerElement/OrganizationUnitNumberInput'

const Wrapper = styled.div`
  /* width: calc(100% / 2 - (15px * 1 / 2));
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) { */
  width: 100%;
  /* } */
`

type Props = {
  survey: Survey
  answer: Answer
}

const LeaderElementList: React.FC<Props> = ({ survey, answer }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getAnswerElement = <T,>(elementUUID: string): T => {
    return answer?.elements.find((element) => element.uuid === elementUUID) as T
  }

  if (!survey) return <></>
  return (
    <div>
      {!answer && <div className="text-center text-gray text-sm">{t.survey.analysis.averageValues.noDataAvailable}</div>}
      {!!answer && (
        <>
          <div className="flex flex-col flex-wrap gap-[15px]">
            {survey.elements.map(
              (element) =>
                // check if element type is in Answer-Type enum
                !!AnswerType[element.type] && (
                  <Wrapper className="shadow-lg bg-white p-3" key={element.uuid}>
                    {element.type === Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION && (
                      <DynamicOptionsWithNumberAndSelection element={element} answerElement={getAnswerElement(element.uuid)} />
                    )}
                    {element.type === Type.ORGANIZATION_UNIT_NUMBER_INPUT && (
                      <OrganizationUnitNumberInput survey={survey} element={element} answerElement={getAnswerElement(element.uuid)} />
                    )}
                  </Wrapper>
                ),
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default LeaderElementList
